import { styled } from '@mui/material';

import {
  Box,
  Button,
  ButtonsContainer,
  Modal,
  Typography,
  useModalContext,
} from '@app-velocity/ui';

import { useI18n } from '@app-velocity/i18n';
import { CrownIcon } from '@app-velocity/icons';

const StyledDescription = styled(Box)({
  textAlign: 'center',
  maxWidth: 450,
});

const StyledTitle = styled(Typography)(({ theme }) => ({
  fontSize: 18,
  marginBottom: theme.spacing(2),
  textAlign: 'center',
}));

const StyledText = styled(Typography)({
  color: 'var(--text-text-secondary-color)',
  whiteSpace: 'pre-line',
});

const IconContainer = styled('div')({
  textAlign: 'center',
  svg: {
    stroke: 'var(--button-button-primary-color)',
  },
});

export const ContactTeamAdminModalContent = () => {
  const { t } = useI18n();
  const { closeModal } = useModalContext();

  return (
    <Modal data-testid="contact-team-admin-modal">
      <Modal.Content>
        <IconContainer>
          <CrownIcon />
        </IconContainer>
        <StyledDescription>
          <StyledTitle variant="header" component="h2">
            {t('users:contact_team_admin.title')}
          </StyledTitle>
          <StyledText variant="body2">
            {t('users:contact_team_admin.description')}
          </StyledText>
        </StyledDescription>
        <ButtonsContainer direction="vertical">
          <Button
            variant="contained"
            color="secondary"
            onClick={() => closeModal()}
          >
            {t('shared:close')}
          </Button>
        </ButtonsContainer>
      </Modal.Content>
    </Modal>
  );
};
